export default __webpack_public_path__ + "static/media/wallet_icon.13111207.svg";